import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=6dccc632&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=js&"
export * from "./EmptyState.vue?vue&type=script&lang=js&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmptyState.vue?vue&type=style&index=1&id=6dccc632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dccc632",
  null
  
)

export default component.exports